module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/knight-3.affde813.png";